<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1670 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #colType="{text}">
      <span>{{ text.colType - 0 ? '自动' : '手动' }}</span>
    </template>
    <template #seoUrl="{text}">
      <a-typography-paragraph
        :copyable="{
          tooltip: false,
          text: text?.fullSeoUrl,
          onCopy: function() {
            message.success('复制成功')
          }
        }"
        v-if="searchParams.terminalId - 0 === 1"
      >
        {{ text.seoUrl }}
      </a-typography-paragraph>
      <span v-else>
        {{ text.seoUrl }}
      </span>
    </template>
    <template #mixColIds="{ text }">
      <span>{{ formatMixColIds(text.mixColIds) }}</span>
    </template>
    <template #status="{text}">
      <a-popconfirm
        :title="`是否${text.status ? '禁用' : '启用'}?`"
        ok-text="确定"
        cancel-text="取消"
        @confirm="
          () =>
            col_activeCol_post(
              deletePeopleGoodsFlag({ ...text, status: text.status ? 0 : 1 })
            )
        "
        @cancel="cancel"
      >
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :checked="text.status - 0 ? true : false"
        />
      </a-popconfirm>
    </template>
    <template #peopleGoodsFlag="{text}">
      <a-popconfirm
        :title="`是否${text.peopleGoodsFlag - 0 ? '禁用' : '启用'}?`"
        ok-text="确定"
        cancel-text="取消"
        @confirm="
          () =>
            col_activeCol_post({
              ...text,
              peopleGoodsFlag: text.peopleGoodsFlag - 0 ? 0 : 1,
              peopleGoodsSpecialFlag:
                (text.peopleGoodsFlag - 0 ? 0 : 1) === 1 ? 0 : null
            })
        "
        @cancel="cancel"
      >
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :checked="text.peopleGoodsFlag - 0 ? true : false"
        />
      </a-popconfirm>
    </template>
    <template #promotionFlag="{text}">
      <div>
        {{
          text.promotionFlag - 0 === 1
            ? '是'
            : text.promotionFlag - 0 === 0
            ? '否'
            : ''
        }}
      </div>
    </template>
    <template #deal="{record, text}">
      <div class="tal">
        <a-button
          type="link"
          @click="jumpPage('CollectionDetail', { ...text, ...searchParams })"
          >编辑</a-button
        >
        <a-button type="link" @click="() => col_queryColLog_post({ ...text })"
          >日志</a-button
        >

        <a-dropdown>
          <EllipsisOutlined />
          <template #overlay>
            <a-menu>
              <a-menu-item key="1">
                <AssignProductsTop :col-id="record.colId" />
              </a-menu-item>
              <a-menu-item key="3">
                <a-popconfirm
                  title="确定复制该collection吗?"
                  trigger="click"
                  @confirm="() => handleCopy({ id: record.colId })"
                  @cancel="cancel"
                >
                  <a-button type="link">复制本collection</a-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item key="2" v-if="text.showDel">
                <span v-btnroot="permissionBtn">
                  <a-popconfirm
                    title="是否确定删除该商品?"
                    ok-text="确定"
                    cancel-text="取消"
                    trigger="click"
                    @confirm="() => deleteFun({ ...text })"
                    @cancel="cancel"
                  >
                    <a-button type="link">删除</a-button>
                  </a-popconfirm>
                </span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </template>
    <template #enableTest="{ text }">
      {{ text == 1 ? '是' : '否' }}
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
import { EllipsisOutlined } from '@ant-design/icons-vue'
import AssignProductsTop from './AssignProductsTop.vue'
import { message } from 'ant-design-vue'
export default {
  components: {
    EllipsisOutlined,
    AssignProductsTop
  },
  setup() {
    const columns = ref([
      {
        title: '编码',
        dataIndex: 'colId',
        key: 'colId',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '标题',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        resizable: true,
        align: 'center'
      },
      {
        title: 'Shopfiy对应ID',
        dataIndex: 'shopifyColId',
        key: 'shopifyColId',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '类型',
        slots: { customRender: 'colType' },
        key: 'colType',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: 'SEO',
        slots: { customRender: 'seoUrl' },
        key: 'seoUrl',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '混合collection',
        key: 'mixColIds',
        slots: { customRender: 'mixColIds' },
        resizable: true,
        align: 'center',
        width: 140
      },
      {
        title: '创建人',
        dataIndex: 'creatorName',
        key: 'creatorName',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center',
        width: 120
      },
      // {
      //   title: '更新人',
      //   dataIndex: 'updatorName',
      //   key: 'updatorName',
      //   resizable: true,
      //   align: 'center',
      //   width: 120
      // },
      // {
      //   title: '更新时间',
      //   dataIndex: 'updateTime',
      //   key: 'updateTime',
      //   resizable: true,
      //   align: 'center',
      //   width: 120
      // },
      {
        title: '是否启用',
        slots: { customRender: 'status' },
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '人货场状态',
        slots: { customRender: 'peopleGoodsFlag' },
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '是否促销专用',
        slots: { customRender: 'promotionFlag' },
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '关联终端编码',
        dataIndex: 'releationId',
        key: 'releationId',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: 'AB测试组名称',
        dataIndex: 'testName',
        key: 'testName',
        resizable: true,
        ellipsis: true,
        align: 'center',
        width: 100
      },
      {
        title: '是否启用AB测试',
        dataIndex: 'enableTest',
        key: 'enableTest',
        resizable: true,
        align: 'center',
        slots: { customRender: 'enableTest' },
        width: 100
      },
      // {
      //   title: 'SEO链接',
      //   dataIndex: 'seoUrl',
      //   key: 'seoUrl',
      //   resizable: true,
      //   align: 'center',
      //   width: 180
      // },
      {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        width: 200
      }
    ])
    const formatMixColIds = value => {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      if (Array.isArray(value)) {
        return value.length ? value.join(',') : ''
      }
      return String(value)
    }
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      formatMixColIds,
      message,
      columns,
      permissionBtn: 'coll_list_delete',
      ...toRefs(inject('initState'))
    }
  }
}
</script>
